import PortalIdParser from 'PortalIdParser';
const portalId = PortalIdParser.get();
export const TOPIC_CLUSTERS_DASHBOARD_LINK = `/content-strategy/${portalId}/clusters`;
export const MAX_CLUSTERS_LIMIT = 1000;
export const MAX_SUBTOPICS = 100;
export const TopicTypes = {
  CLUSTER: 'CLUSTER',
  SUBTOPIC: 'SUBTOPIC'
};